__turbopack_context__.v({
  "animate": "Tutorial-module__m3OryW__animate",
  "animationWrapper": "Tutorial-module__m3OryW__animationWrapper",
  "bar": "Tutorial-module__m3OryW__bar",
  "bar-mobile": "Tutorial-module__m3OryW__bar-mobile",
  "container": "Tutorial-module__m3OryW__container",
  "container1": "Tutorial-module__m3OryW__container1",
  "container2": "Tutorial-module__m3OryW__container2",
  "icon": "Tutorial-module__m3OryW__icon",
  "icon-sequence": "Tutorial-module__m3OryW__icon-sequence",
  "icon-sequence-border": "Tutorial-module__m3OryW__icon-sequence-border",
  "icon1": "Tutorial-module__m3OryW__icon1",
  "icon2": "Tutorial-module__m3OryW__icon2",
  "icon3": "Tutorial-module__m3OryW__icon3",
  "iconWrapper": "Tutorial-module__m3OryW__iconWrapper",
  "main": "Tutorial-module__m3OryW__main",
});
